import { initializeErrorReporting } from '@eventbrite/error-reporting';
import { loadableReady } from '@loadable/component';
import React from 'react';
import { hydrate, render } from 'react-dom';
import { initializeStatsigSdk } from './actions/statsig';
import App from './app';
import {
    initDimensionsFromState,
    trackInitialPageView,
} from '@eventbrite/site-analytics';
import GenericErrorMessage from './components/errorNotification/GenericErrorMessage';
import logger from '@eventbrite/client-logger';
import {
    getLocaleOverride,
    setupAsync,
    getParentLocale,
} from '@eventbrite/i18n';
import { initDatadogRUM } from './initDatadogRUM';

const root = document.getElementById('root');
const props = window.__SERVER_DATA__;
const isProd = (domain = {}) => domain.includes('eventbrite');

const main = async () => {
    if (!props) {
        throw new Error('props is missing');
    }
    if (!root) {
        throw new Error('root is null');
    }

    // __LOCALS__ is defined only when running checkout using `bolt dev`. In this situation __SERVER_DATA__ does not have app_name nor app_version
    const appName =
        props.app_name ??
        window.__LOCALS__.application.name
            .replace('@eventbrite/', '')
            .replace('@eventbrite/', '');
    const appVersion = props.app_version;

    const parentLocale = getParentLocale(
        getLocaleOverride() || props.env.localeInfo.locale,
    );

    try {
        initializeErrorReporting({
            metaData: {
                tags: {
                    event_id: props.event.id,
                },
            },
        });
        if (parentLocale !== 'en_US') {
            await setupAsync({
                parentLocale,
                translations:
                    /* webpackChunkName: "checkout-i18n-translation" */ import(
                        `./i18n/translations/${parentLocale}.json`
                    ),
            });
        }
        await initializeStatsigSdk(props);
    } finally {
        // render app with server props to the DOM
        loadableReady(() => {
            hydrate(
                <App {...props} appName={appName} appVersion={appVersion} />,
                root,
            );
        });

        initDimensionsFromState(props);
        trackInitialPageView(props.gaSettings);

        if (isProd(props.env.ebDomain)) {
            initDatadogRUM({
                app: { name: appName, version: appVersion },
            });
        }
    }
};

try {
    main();
} catch (error) {
    logger.error('checkoutWidget main error:', {
        error: error.message ? error.message : error,
        props,
    });
    if (root) {
        try {
            render(<GenericErrorMessage />, root);
        } catch (e) {
            logger.error('GenericErrorMessage error:', {
                error: e,
            });
        }
    }
}
